module.exports = __webpack_public_path__ + "img/award.9a1a8216.png";